module.exports = __webpack_public_path__ + "img/loading.ac431f7d.gif";